import { supabase } from '../supabaseClient';

/** 학년도 자료 묶음(사용자 × 학년도). 일일기록·할일노트·예산노트·공유 할일 보드가 bundle_id 로 소속 */
export type AcademicYearBundle = {
  id: string;
  owner_id: string;
  academic_year: number;
  ends_on: string;
  grace_ends_on: string;
  created_at: string;
};

/** 내 묶음 목록(현재 학년도 묶음은 없으면 서버가 만든다). 마이그레이션 전이면 빈 목록 */
export async function listMyYearBundles(): Promise<AcademicYearBundle[]> {
  const { data, error } = await supabase.rpc('cp_my_year_bundles');
  if (error) return [];
  return ((data as AcademicYearBundle[] | null) ?? []).filter((b) => b && typeof b.academic_year === 'number');
}
